<template>
    <div class="layout-reminder-popup layout-reminder-share" @click.stop="clickReminder">
        <!-- 底部遮罩层 -->
        <div v-if="startCheck && (!shareExtTime[curKey] || (shareExtTime[curKey] && shareExtTime[curKey] < 0))" class="layout-overlay"></div>

        <!-- 1、保存弹框 -->
        <div v-if="shareExtTime[shareKeyArr[0]] && shareExtTime[shareKeyArr[0]] < 0" class="layout-reminder-content">
            <div class="layout-reminder-share-title dsp-flex">
                <div class="title-side"></div>
                <div class="title-middle"></div>
                <div class="title-side title-right">
                    <span class="title-box">
                        <span class="title-span"><span class="title-save">保存</span></span>
                    </span>
                </div>
            </div>
            <div class="layout-reminder-share-bubble-1"></div>
        </div>

        <!-- 2、起盘弹框 -->
        <div v-if="shareExtTime[shareKeyArr[1]] && shareExtTime[shareKeyArr[1]] < 0" class="layout-reminder-content">
            <div class="layout-reminder-share-title dsp-flex">
                <div class="title-side"></div>
                <div class="title-middle"></div>
                <div class="title-side title-right title-right-edit">
                    <span class="title-box">
                        <span>起盘</span>
                    </span>
                </div>
            </div>
            <div class="layout-reminder-share-bubble-2"></div>
        </div>
        
    </div>
</template>

<script>
export default {
    name: 'ReminderShare',
    computed: {
        shareExtTime() {
            return this.$store.state.reminder.shareExtTime
        },
        shareKeyArr() {
            return this.$store.state.reminder.shareKeyArr
        }
    },
    data() {
        return {
            startCheck: false,
            keyIndex: 0,
            curKey: ''
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
        setTimeout(() => {
            me.checkData();
        }, 1000);
    },
    methods: {
        initDom() {
            this.$el.style.width = innerWidth + 'px';
            this.$el.style.height = innerHeight + 'px';
        },
        checkData() {
            var me = this,
                shareData = this.$store.state.share.shareData,
                curPath = this.$router.history.current.path;
            if(curPath.indexOf('share') == -1 || (shareData && shareData.type != 4)) {
                this.$store.state.reminder.showShareReminder = false;
                // this.$store.state.reminder.showVersionReminder = true;
                this.$store.state.reminder.showDownloadReminder = true;
                return;
            }
            this.startCheck = true;
            this.$store.state.reminder.showVersionReminder = false;
            this.$store.state.reminder.showDownloadReminder = false;
            
            this.curKey = this.shareKeyArr[this.keyIndex];
            console.log('ReminderShare:::::::checkData------', this.curKey, this.shareExtTime[this.curKey])
            if(!this.shareExtTime[this.curKey] || this.shareExtTime[this.curKey] == -1) {
                this.$set(this.$store.state.reminder.shareExtTime, this.curKey, -1);
                // 自动跳到下一步
                // setTimeout(() => {
                //     me.clickReminder();
                // }, 5000);
            }else {
                if(this.keyIndex < this.shareKeyArr.length - 1) {
                    this.keyIndex++;
                    this.checkData();
                }else {
                    this.$store.state.reminder.showShareReminder = false;
                    // this.$store.state.reminder.showVersionReminder = true;
                    this.$store.state.reminder.showDownloadReminder = true;
                }
            }
        },
        clickReminder() {
            if(this.curKey == '') { return; }
            var params = {};
                params['shareExtTime'] = Object.assign({}, this.shareExtTime);
                params['shareExtTime'][this.curKey] = 1;
            console.log('clickReminder', params, this.keyIndex)
            
            var me = this;
            this.$store.dispatch('reminder/udpateExtList', {
                params: params,
                cb: function() {
                    if(me.keyIndex < 1) {
                        me.keyIndex++;
                        me.checkData();
                    }else {
                        me.curKey = '';
                        me.startCheck = false;
                        me.$store.state.reminder.showShareReminder = false;
                        // me.$store.state.reminder.showVersionReminder = true;
                        me.$store.state.reminder.showDownloadReminder = true;
                    }
                }
            })
        }
    }
}
</script>